import React, { CSSProperties } from "react";
import classnames from "classnames";
import styles from "./cardbox.module.scss";

interface CardBoxProps {
  className?: string;
  padding?: boolean;
  style?: CSSProperties;
}

const CardBox: React.FC<CardBoxProps> = props => {
  const { children, className, style = {} } = props;

  return (
    <div className={classnames(styles.cardbox, className)} style={{ ...style }}>
      <div></div>
      <div>{children}</div>
      <div></div>
    </div>
  );
};

export default CardBox;
export { CardBox };
